var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Form } from 'antd';
import React from 'react';
import { EditableContext } from "./EditableCell";
const EditableRow = (_a) => {
    var { index } = _a, props = __rest(_a, ["index"]);
    const [form] = Form.useForm();
    return (React.createElement(Form, { form: form, component: false },
        React.createElement(EditableContext.Provider, { value: form },
            React.createElement("tr", Object.assign({}, props)))));
};
export default EditableRow;
